// Menu lateral por conta (settings.sidebar_menu, configurado no Super Admin).
// Sem configuração, o menu fica exatamente como o padrão do Fluxi.
// As chaves são as mesmas de AccountSidebarMenu::ITENS_DO_MENU no backend.
export const ITEM_DO_MENU_POR_CHAVE = {
  calendario: 'Google Calendar',
  caixa_de_entrada: 'Inbox',
  conversas: 'Conversation',
  kanban: 'Kanban',
  chat_interno: 'Internal Chat',
  contatos: 'Contacts',
  pessoas: 'CRM Pessoas',
  registros_diarios: 'CRM Registros',
  captain: 'Captain',
  empresas: 'Companies',
  relatorios: 'Reports',
  campanhas: 'Campaigns',
  central_de_ajuda: 'Portals',
  configuracoes: 'Settings',
};

// Itens dentro de "Conversas" (AccountSidebarMenu::SUBITENS_DE_CONVERSAS).
export const SUBITEM_DE_CONVERSAS_POR_CHAVE = {
  conversas_todas: 'All',
  conversas_mencoes: 'Mentions',
  conversas_nao_atendidas: 'Unattended',
  conversas_pastas: 'Folders',
  conversas_times: 'Teams',
  conversas_canais: 'Channels',
  conversas_etiquetas: 'Labels',
};

const ocultarSubitensDeConversas = (item, ocultos) => {
  if (item.name !== 'Conversation' || !Array.isArray(item.children)) {
    return item;
  }
  const nomesOcultos = new Set(
    ocultos.map(chave => SUBITEM_DE_CONVERSAS_POR_CHAVE[chave]).filter(Boolean)
  );
  if (!nomesOcultos.size) return item;
  return {
    ...item,
    children: item.children.filter(filho => !nomesOcultos.has(filho.name)),
  };
};

const nomesDasChaves = chaves =>
  new Set(chaves.map(chave => ITEM_DO_MENU_POR_CHAVE[chave]).filter(Boolean));

/**
 * Aplica ordem e visibilidade da conta sobre os itens do menu.
 * Formato novo: todos os itens aparecem (na ordem configurada, o resto depois),
 * menos os ocultos para o papel de quem está logado.
 * Formato antigo (sem ocultos_para_admins): só os itens de `ordem`, para todos.
 * Ocultar é só navegação: as permissões de cada rota continuam valendo.
 */
export const aplicarMenuDaConta = (itens, configuracao, ehAdministrador) => {
  const ordem = configuracao?.ordem;
  if (!Array.isArray(ordem) || !ordem.length) return itens;

  const legado = !Array.isArray(configuracao.ocultos_para_admins);
  const chavesOcultas =
    (ehAdministrador
      ? configuracao.ocultos_para_admins
      : configuracao.ocultos_para_agentes) || [];
  const ocultos = nomesDasChaves(chavesOcultas);
  const porNome = new Map(itens.map(item => [item.name, item]));
  const ordenados = ordem
    .map(chave => porNome.get(ITEM_DO_MENU_POR_CHAVE[chave]))
    .filter(Boolean);
  const restantes = legado
    ? []
    : itens.filter(item => !ordenados.includes(item));

  return [...ordenados, ...restantes]
    .filter(item => !ocultos.has(item.name))
    .map(item => ocultarSubitensDeConversas(item, chavesOcultas));
};
